import { render, staticRenderFns } from "./PromoDisclosure.vue?vue&type=template&id=e52ff884&"
import script from "./PromoDisclosure.vue?vue&type=script&lang=js&"
export * from "./PromoDisclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports